import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { hasCap, hasAnyCapUnder } from '@/lib/capabilities';
import { useEffectiveMe } from '@/lib/effectiveMe';

/**
 * Capability-based route guard. Renders `children` only if the current user
 * holds `cap` (exact + family wildcard + CEO wildcard match) OR if any of the
 * `anyPrefix` capabilities are present in the effective set.
 *
 * On denial we redirect to `/access-denied` where a calm, jargon-free message
 * is shown — never a technical "Permesso negato: <code>" toast. Backend keeps
 * enforcing 403 regardless of what the client renders.
 */
export default function RequireCap({ cap, anyPrefix, fallback = '/access-denied', children }) {
  const { loading } = useAuth();
  const me = useEffectiveMe();
  if (loading || !me) return null;   // ProtectedLayout shows the loading state
  const ok =
    (cap && hasCap(me, cap)) ||
    (anyPrefix && anyPrefix.some((p) => hasAnyCapUnder(me, p)));
  if (!ok) return <Navigate to={fallback} replace />;
  return children;
}

export function RequireGlobalCeo({ fallback = '/access-denied', children }) {
  const { loading } = useAuth();
  const me = useEffectiveMe();
  if (loading || !me) return null;
  const isGlobalCeo = me.is_global === true && (me.role_codes || []).includes('CEO');
  if (!isGlobalCeo) return <Navigate to={fallback} replace />;
  return children;
}
